import { useCallback, useEffect, useState } from "react";
import {
  applyAdminTheme,
  clearAdminThemeFromDom,
  readStoredAdminTheme,
  resolveAdminTheme,
  toggleAdminTheme,
  type AdminTheme,
} from "../lib/adminTheme.js";

export function useAdminTheme() {
  const [theme, setTheme] = useState<AdminTheme>(() => resolveAdminTheme());

  useEffect(() => {
    applyAdminTheme(resolveAdminTheme());
    setTheme(resolveAdminTheme());

    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const onSystemChange = () => {
      if (readStoredAdminTheme() !== null) return;
      const resolved = resolveAdminTheme();
      applyAdminTheme(resolved);
      setTheme(resolved);
    };

    media.addEventListener("change", onSystemChange);
    return () => {
      media.removeEventListener("change", onSystemChange);
      clearAdminThemeFromDom();
    };
  }, []);

  const toggleTheme = useCallback(() => {
    setTheme((current) => toggleAdminTheme(current));
  }, []);

  return { theme, toggleTheme };
}
